module.exports = __webpack_public_path__ + "img/who_has_worked_with_us.c7132a2e.png";